import {Grid, Typography} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import {Answer, AnswerProps} from './Answer'
import {classes} from './Question.classes'
import {useQuestionArrangement} from './Question.hooks'

type Props = Omit<AnswerProps, 'answer'>

export function Question({handleAnswerClick, question}: Props): React.ReactElement<Props> {
  const {alignItems, direction} = useQuestionArrangement(question)

  return (
    <Grid
      alignItems={alignItems}
      className={classes.root}
      direction={direction}
      justify="space-between"
      wrap="nowrap"
      container
    >
      <Grid className={classes.text} item>
        <Typography group="tight" thickness="regular" variant="caption1">
          {question.text}
        </Typography>
      </Grid>
      <Grid
        className={clsx(classes.answers, direction === 'column' && classes.column)}
        size="xs"
        wrap="nowrap"
        container
        item
      >
        {question.answers.map(answer => (
          <Grid key={answer.id} item>
            <Answer answer={answer} handleAnswerClick={handleAnswerClick} question={question} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
